<!-- eslint-disable @angular-eslint/template/no-call-expression -->

<div class="tw:shadow-lowDrop tw:bg-white tw:relative tw:flex tw:sm:shadow-none tw:sm:sticky tw:sm:top-0 tw:sm:z-10">
  <nav
    class="tw:flex tw:flex-1 tw:items-center tw:justify-between tw:max-w-7xl tw:mx-auto tw:py-5 tw:sm:py-[1.0625rem] tw:px-[6px] tw:sm:px-[2.5rem]"
  >
    <div class="tw:flex tw:flex-1 tw:gap-8 tw:items-center tw:h-fit">
      <a
        class="tw:flex tw:items-center"
        (click)="trackEvent('Home Navigation', 'Click Logo')"
        aria-label="Aller sur le dashboard"
        i18n-aria-label="@@wzb-money-header.aria-home-navigation"
        routerLink="/"
      >
        <svg
          class="tw:w-[6.75rem] tw:h-[2.187rem] tw:sm:w-[6.625rem] tw:sm:h-10"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 146 39"
        >
          <path
            fill="#000028"
            d="M88.5 33.59h-5.15v-4.65h5.14c1.85 0 2.91.78 2.91 2.33 0 1.45-.97 2.32-2.9 2.32Zm-5.15-13.75h4.66c1.65 0 2.71.87 2.71 2.21 0 1.56-1.06 2.33-2.71 2.33h-4.66v-4.54Zm9.62 6.2A5.16 5.16 0 0 0 96.95 21c0-3.7-3.3-6-8.63-6H77.14v23.53h11.55c5.53 0 9.12-2.52 9.12-6.59a5.9 5.9 0 0 0-4.86-5.9M21.34 38.53h6.02L35.9 15h-6.5l-8.06 23.53Zm-4.45-18.59L12.8 33.3 6.7 15H0l8.63 23.53h8.06l6.4-18.6h-6.2Zm54.91-.97V15H51.93v4.94h11.64L51.52 34.46v4.07H71.9v-4.94H59.68L71.8 18.97ZM46 15h-6.15v23.53h6.14V15Zm62.87 0h-6.14v23.53h6.14V15Zm12.29 0h-6.14v23.53h6.14V15Z"
          />
          <path fill="#000028" d="M108.87 15h-6.14v23.53h6.14V15ZM46 15h-6.15v23.53h6.14V15Z" />
          <path
            fill="#8683FF"
            d="M145.2 24a7.5 7.5 0 0 1-5.3-2.17 7.36 7.36 0 0 1 0-10.46 7.5 7.5 0 0 1 5.3-2.17V24ZM121.77.8c0 1.96.79 3.85 2.19 5.23a7.51 7.51 0 0 0 10.57 0A7.37 7.37 0 0 0 136.7.8h-14.94Z"
          />
          <path
            fill="#000028"
            d="M134.35 2.93c-.68.84-1.26 1.76-1.73 2.73l7.66 7.57c.98-.47 1.91-1.04 2.76-1.71l-8.7-8.6Zm9.83-1.13a6.25 6.25 0 0 0-7.47-1l8.48 8.4a6.12 6.12 0 0 0-1.01-7.4Zm-13.46 13.33a21.1 21.1 0 0 0 6.28-.69l-5.58-5.53a20.68 20.68 0 0 0-.7 6.22Z"
          />
          <path
            fill="#8683FF"
            d="M144.18 10.53c.4-.4.74-.84 1.01-1.33L136.71.8a6.2 6.2 0 0 0-1.34 1c-.36.36-.7.74-1 1.13l8.67 8.6c.4-.32.78-.65 1.14-1Zm-12.76-1.62 5.58 5.53c1.13-.3 2.23-.7 3.28-1.2l-7.65-7.58a17.57 17.57 0 0 0-1.21 3.25Z"
          />
        </svg>
      </a>

      <a
        class="tw:hidden tw:sm:block tw:hover:underline tw:text-nowrap"
        [routerLink]="['/', 'helps', 'summary']"
        (click)="trackEvent('Home Navigation', 'Click Summary')"
        i18n="@@wzb-money-header.update-situation"
        >Mettre à jour ma situation</a
      >

      <a
        class="tw:hidden tw:sm:block tw:hover:underline tw:text-nowrap"
        [routerLink]="['/', 'helps']"
        (click)="resetForm.emit(); trackEvent('Home Navigation', 'Click Reset')"
        i18n="@@wzb-money-header.reset-simulation"
        >Recommencer ma simulation</a
      >
    </div>

    <div class="tw:flex tw:gap-4 tw:items-center tw:sm:gap-8 tw:h-fit">
      @if (isTrustpilotEnabled()) {
        <app-trust-box-widget
          class="tw:flex tw:max-w-60 tw:items-center"
          [readonly]="true"
          [trustBoxLocale]="locale()"
          trustBoxType="microTrustScore"
          trustBoxId="dashboard-header-trustbox"
        />
      }

      <div class="tw:hidden tw:sm:block">
        <app-menu class="tw:flex tw:h-fit" [items]="menuItems()">
          <div class="tw:text-xs tw:font-semibold tw:cursor-pointer tw:leading-tight">
            <svg class="tw:w-8 tw:h-8" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.3337 21.3333H4.00033C3.6467 21.3333 3.30756 21.4738 3.05752 21.7239C2.80747 21.9739 2.66699 22.313 2.66699 22.6667C2.66699 23.0203 2.80747 23.3594 3.05752 23.6095C3.30756 23.8595 3.6467 24 4.00033 24H17.3337C17.6873 24 18.0264 23.8595 18.2765 23.6095C18.5265 23.3594 18.667 23.0203 18.667 22.6667C18.667 22.313 18.5265 21.9739 18.2765 21.7239C18.0264 21.4738 17.6873 21.3333 17.3337 21.3333ZM4.00033 10.6667H28.0003C28.3539 10.6667 28.6931 10.5262 28.9431 10.2761C29.1932 10.0261 29.3337 9.68696 29.3337 9.33333C29.3337 8.97971 29.1932 8.64057 28.9431 8.39052C28.6931 8.14048 28.3539 8 28.0003 8H4.00033C3.6467 8 3.30756 8.14048 3.05752 8.39052C2.80747 8.64057 2.66699 8.97971 2.66699 9.33333C2.66699 9.68696 2.80747 10.0261 3.05752 10.2761C3.30756 10.5262 3.6467 10.6667 4.00033 10.6667ZM28.0003 14.6667H4.00033C3.6467 14.6667 3.30756 14.8071 3.05752 15.0572C2.80747 15.3072 2.66699 15.6464 2.66699 16C2.66699 16.3536 2.80747 16.6928 3.05752 16.9428C3.30756 17.1929 3.6467 17.3333 4.00033 17.3333H28.0003C28.3539 17.3333 28.6931 17.1929 28.9431 16.9428C29.1932 16.6928 29.3337 16.3536 29.3337 16C29.3337 15.6464 29.1932 15.3072 28.9431 15.0572C28.6931 14.8071 28.3539 14.6667 28.0003 14.6667Z"
                fill="#000028"
              />
            </svg>
            <ng-container i18n="@@wzb-money-header.menu"> Menu </ng-container>
          </div>
        </app-menu>
      </div>
    </div>
  </nav>
</div>
